import * as React from 'react';
import styled from 'styled-components';
import { Table } from 'reactstrap';

const StyledTableBase = styled(Table)`
    && {
        margin-bottom: 0;

        thead th {
            border-top: 0;
            border-bottom: var(--border-thin) solid var(--surface-border-subtle);
            color: var(--text-muted);
            font-size: 0.78rem;
            font-weight: 700;
            letter-spacing: 0.03em;
            text-transform: uppercase;
            white-space: nowrap;
        }

        tbody td {
            vertical-align: middle;
            border-top: var(--border-thin) solid var(--surface-border-subtle);
            font-size: 0.85rem;
        }

        tbody tr:nth-child(even) {
            background-color: var(--bg-light);
        }
    }
`;

const ScrollContainer = styled.div`
    min-width: 0;
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
`;

/** Primary cell text — bold, strong colour. Use for main identifiers (name, title). */
export const PrimaryText = styled.span`
    font-size: 0.85rem;
    font-weight: 600;
    color: var(--text-strong);
    line-height: 1.35;
`;

/** Secondary cell text — regular weight, muted colour. Use for supporting details. */
export const SecondaryText = styled.span`
    font-size: 0.85rem;
    font-weight: 400;
    color: var(--text-muted);
    line-height: 1.35;
`;

type TableProps = React.ComponentProps<typeof Table>;

interface StyledTableProps extends TableProps {
    /** Wraps the table in a horizontally scrollable container */
    scrollable?: boolean;
}

const StyledTable: React.FC<StyledTableProps> = ({ scrollable, children, ...props }) => {
    const table = <StyledTableBase {...props}>{children}</StyledTableBase>;
    return scrollable ? <ScrollContainer>{table}</ScrollContainer> : table;
};

export default StyledTable;
